<template>
  <h1>SiteDetail</h1>
  {{ site }}
</template>

<script>
import firebase from "@/firebase";

export default {
  created() {
    window.scrollTo(0, 0);
  },

  data() {
    return {
      site: null,
    };
  },

  mounted() {
    const id = this.$route.params.id;
    firebase.firestore
      .collection("sites")
      .doc(id)
      .get()
      .then((snap) => {
        const site = snap.data();
        site.id = snap.id;
        this.site = site;
      })
      .catch((error) => {
        console.error("Error getting documents: ", error);
      });
  },
};
</script>

<style scoped></style>
